import type { FC } from 'react';
import { forwardRef } from 'react';
import type { NumberFormatProps as ReactNumberFormatProps, NumberFormatPropsBase } from 'react-number-format';
import NumberFormatInput from 'react-number-format';
export const persianNumbers: NumberFormatPropsBase['customNumerals'] = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
export interface NumberFormatProps extends ReactNumberFormatProps {}
export const NumberFormat: FC<NumberFormatProps> = forwardRef<HTMLInputElement, NumberFormatProps>(function NumberFormat(props, ref) {
  return <NumberFormatInput allowLeadingZeros allowNegative={false} customNumerals={persianNumbers} getInputRef={ref} {...props} />;
});